import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSV = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 0C15.088 0 6.524 5.768 2.48 14.13h45.04C43.475 5.768 34.91 0 25 0ZM25 50c9.911 0 18.476-5.769 22.52-14.131H2.48c4.044 8.362 12.608 14.13 22.52 14.13Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M19.98 26.087 25 17.392l5.02 8.695H19.98Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M31.522 28.959 25 32.219l-6.522-3.26V24.61h13.044v4.348Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m31.149 17.764-2.306 2.306a5.435 5.435 0 1 1-7.686 0l-2.306-2.306a8.696 8.696 0 1 0 12.297 0Z"
}));
FlagSV.displayName = 'FlagSV';
export default withFlagWrapper(FlagSV);
//# sourceMappingURL=index.js.map